// Lightweight EventEmitter shim to satisfy @azure/storage-blob browser import.
// Provides minimal on/off/emit functionality needed for batching logic.
export class EventEmitter {
	constructor() {
		this._events = {};
	}
	on(event, listener) {
		(this._events[event] ||= []).push(listener);
		return this;
	}
	off(event, listener) {
		const arr = this._events[event];
		if (!arr) return this;
		this._events[event] = arr.filter(l => l !== listener);
		return this;
	}
	emit(event, ...args) {
		const arr = this._events[event];
		if (!arr) return false;
		for (const l of arr) l(...args);
		return true;
	}
}